import { useCallback, useEffect, useRef, useState } from 'react';

import { useTranslation } from 'react-i18next';

import { getSignedURL } from 'api/endpoints/upload';
import ImagePreview from 'components/ImagePreview';
import { getScrollableParent, handleImageSurvey, isElementInView } from 'utils/helper';

const AddPhotoAlternate = require('assets/resources/AddPhotoAlternate.svg').default;

const Image = ({ item }) => {
  const [src, setSrc] = useState('');

  const handleLoadImage = useCallback(async () => {
    const signedURL = await getSignedURL({ blob_name: item.source_blob, bucket_name: item.source_bucket });
    const { signed_url, etag } = signedURL.data;
    const images = await handleImageSurvey([{ signed_url, etag }]);
    if (images.length > 0) {
      images[0]?.url_preview && setSrc(images[0].url_preview);
    }
  }, [item.source_blob, item.source_bucket]);

  useEffect(() => {
    handleLoadImage();
  }, [handleLoadImage]);

  return src && <img className="shadow-image w-full h-full object-cover" src={src} alt="image" />;
};

const ImageOption = (props) => {
  const { t } = useTranslation();
  const { data } = props;
  const [isOpen, setIsOpen] = useState(-1);
  const [showImage, setShowImage] = useState(false);
  const imageContainerRef = useRef(null);

  const check = () => {
    if (isElementInView(imageContainerRef.current)) {
      setShowImage(true);
    }
  };

  useEffect(() => {
    const scrollableParent = getScrollableParent(imageContainerRef.current);
    if (scrollableParent) {
      scrollableParent.addEventListener('scroll', check);
    }
    return () => {
      if (scrollableParent) {
        scrollableParent.removeEventListener('scroll', check);
      }
    };
  }, []);

  useEffect(() => {
    check();
  }, []);

  return (
    <>
      <div>
        <div className="flex items-center gap-2">
          <img src={AddPhotoAlternate} alt="add photo" width={36} height={36} />
          <span className="text-black-102">{t('UPLOAD_IMAGE_INSTRUCTION')}</span>
        </div>
        {data.media_files?.length > 0 && (
          <div className="flex flex-wrap gap-4 mt-4" ref={imageContainerRef}>
            {data.media_files.map((item, index) => (
              <div key={`image-${index}`} className="w-60 h-86.75 flex justify-start items-start bg-black/30" onClick={() => setIsOpen(index)}>
                {showImage && <Image item={item} />}
              </div>
            ))}
          </div>
        )}
      </div>
      {isOpen !== -1 && <ImagePreview close={() => setIsOpen(-1)} data={data.media_files} firstOpen={isOpen} />}
    </>
  );
};

export default ImageOption;
